import React from 'react';
import { skills } from '../data/data';

const SkillsSection = () => {
  return (
    <section id="skills" className="py-32 px-6 text-center">

      {/* TITLE */}
      <h2 className="text-4xl md:text-5xl font-bold mb-16">
        Skills & <span className="text-cyan-400 glow">Expertise</span>
      </h2>

      {/* CONTAINER */}
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8">

        {skills.map((category, index) => (
          <div
            key={index}
            className="bg-[#111]/50 backdrop-blur-lg border border-cyan-400/10 rounded-2xl p-8 text-left transition-all duration-300 hover:border-cyan-400/30 hover:shadow-[0_0_25px_rgba(0,255,255,0.12)]"
          >
            {/* CATEGORY TITLE */}
            <h3 className="text-xl font-semibold text-cyan-400 mb-6">
              {category.category}
            </h3>

            {/* SKILLS TAGS */}
            <div className="flex flex-wrap gap-3">
              {category.items.map((skill, i) => (
                <span
                  key={i}
                  className="px-4 py-1.5 rounded-full text-sm bg-gray-800/60 text-gray-300 border border-gray-700/50 transition-all duration-300 hover:border-cyan-400/40 hover:text-cyan-300 hover:shadow-[0_0_10px_rgba(0,255,255,0.2)]"
                >
                  {skill.name}
                </span>
              ))}
            </div>

          </div>
        ))}

      </div>

    </section>
  );
};

export default SkillsSection;